var map = {
	"./decidim/avatar-multiuser.png": 80666,
	"./decidim/brands/google.svg": 42485,
	"./decidim/cc-badge.png": 40228,
	"./decidim/decidim-logo.svg": 5608,
	"./decidim/default-avatar.svg": 43504,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 5964,
	"./decidim/icons.svg": 88491,
	"./decidim/pattern.png": 972,
	"./decidim/placeholder-card-g.svg": 90313,
	"./decidim/placeholder-card-l.svg": 38658,
	"./decidim/placeholder.jpg": 66561,
	"./decidim/remixicon.symbol.svg": 19557,
	"./decidim/vendor/leaflet/layers-2x.png": 71492,
	"./decidim/vendor/leaflet/layers.png": 48739,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 49310,
	"./decidim/vendor/leaflet/marker-icon.png": 72197,
	"./decidim/vendor/leaflet/marker-shadow.png": 11626,
	"./decidim/vendor/social-share-button/douban.svg": 19572,
	"./decidim/vendor/social-share-button/email.svg": 39505,
	"./decidim/vendor/social-share-button/facebook.svg": 65271,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 16937,
	"./decidim/vendor/social-share-button/hacker_news.svg": 7489,
	"./decidim/vendor/social-share-button/linkedin.svg": 75057,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 19218,
	"./decidim/vendor/social-share-button/pinterest.svg": 935,
	"./decidim/vendor/social-share-button/reddit.svg": 66827,
	"./decidim/vendor/social-share-button/telegram.svg": 9006,
	"./decidim/vendor/social-share-button/tumblr.svg": 70253,
	"./decidim/vendor/social-share-button/twitter.svg": 97024,
	"./decidim/vendor/social-share-button/vkontakte.svg": 72814,
	"./decidim/vendor/social-share-button/wechat.svg": 72553,
	"./decidim/vendor/social-share-button/whatsapp.svg": 44465,
	"./decidim/vendor/social-share-button/x.svg": 63961,
	"./decidim/vendor/social-share-button/xing.svg": 72727
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86479;